import { render, staticRenderFns } from "./MyWalletOrbitOverview.vue?vue&type=template&id=3a0d645d&scoped=true"
import script from "./MyWalletOrbitOverview.vue?vue&type=script&lang=ts"
export * from "./MyWalletOrbitOverview.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletOrbitOverview.vue?vue&type=style&index=0&id=3a0d645d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0d645d",
  null
  
)

export default component.exports